import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  id: "columns",
  class: "columns is-inline-flex is-multiline is-mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_Cell = _resolveComponent("Cell")!
  const _component_Tools = _resolveComponent("Tools")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.show_search)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_Search)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      id: "grid",
      class: "container is-max-desktop py-5",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideForm && _ctx.hideForm(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (n) => {
          return (_openBlock(), _createBlock(_component_Cell, {
            class: _normalizeClass(["image column p-0", {'selected': n === _ctx.selected_id, 'is-half': _ctx.tiles === 4, 'is-one-third': _ctx.tiles === 9, 'is-one-quarter': _ctx.tiles === 16, 'is-one-fifth': _ctx.tiles === 25}]),
            key: n,
            id: n,
            style: _normalizeStyle({'box-shadow': '0px 0px 0px 1px ' + (n === _ctx.selected_id ? _ctx.complementary_color : _ctx.color) })
          }, null, 8, ["class", "id", "style"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Tools)
  ], 64))
}